import { Box, Paper, Typography, useTheme } from "@mui/material";
import DataImportWizard from "@/bids/CustomBidImportWizardNew";

/**
 * WizardPanel — renders the bid import configuration wizard.
 *
 * Props:
 *  - previewData: object | null — excel sheet preview data
 *  - initialConfig: object | null — initial wizard configuration from AI
 *  - onPrimarySubmit: (config) => void — "Preview Configuration"
 *  - onSecondarySubmit: (config) => void — "Sync to AI Assistant"
 *  - onCancel: () => void
 *  - isImporting: boolean
 *  - onConfigChange: (config) => void
 *  - onHighlightGroupDepth: (depth) => void
 */
export default function WizardPanel({
    previewData,
    initialConfig,
    onPrimarySubmit,
    onSecondarySubmit,
    onCancel,
    isImporting,
    onConfigChange,
    onHighlightGroupDepth,
    isSheetFile = null,
}) {
    const theme = useTheme();

    const showUnsupportedMessage = isSheetFile === false;

    return (
        <Paper
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: 3,
                background: theme.palette.background.default,
                overflow: "auto",
            }}
        >
            <Box sx={{ px: 2, pt: 2, pb: 1 }}>
                <Typography variant="subtitle2" color="text.secondary">
                    Manual Configuration
                </Typography>
            </Box>

            <Box sx={{ flex: 1, overflow: "auto" }}>
                {showUnsupportedMessage ? (
                    <Box sx={{ px: 2, py: 3 }}>
                        <Typography variant="body2" color="text.secondary">
                            Manual configuration is only available for
                            spreadsheet files (.xlsx, .xls, .xlsm). PDF and DOCX
                            files are processed directly by the AI assistant.
                        </Typography>
                    </Box>
                ) : (
                    <DataImportWizard
                        previewData={previewData}
                        initialConfig={initialConfig}
                        onPrimarySubmit={onPrimarySubmit}
                        primarySubmitText="Preview Configuration"
                        onSecondarySubmit={onSecondarySubmit}
                        secondarySubmitText="Sync to AI Assistant"
                        onCancel={onCancel}
                        isImporting={isImporting}
                        onConfigChange={onConfigChange}
                        onHighlightGroupDepth={onHighlightGroupDepth}
                    />
                )}
            </Box>
        </Paper>
    );
}
